import { legacyTheme, styled } from '@prose-ui/legacy';

const GridItem = styled('section')({
  minWidth: '100%',
  maxWidth: '400px',
  marginBottom: 40,
  display: 'flex',
  flexFlow: 'column',
  alignItems: 'center',
  [legacyTheme.breakpoints.up('md')]: {
    minWidth: '340px',
    maxWidth: '340px',
  },
});

export const SocialMediaGridItem = styled(GridItem)({
  '& h3': {
    marginBottom: 10,
  },
  '& div img': {
    marginRight: 10,
  },
  '& a': {
    textDecoration: 'underline',
    color: 'inherit',
  },
});
